export const Home = "/Home";
export const SIGN_UP = "/SignUp";
export const SIGN_IN = "/SignIn";
export const GetYourReport = "/GetYourReport";
export const ACCOUNT = "/Account";
export const ADMIN = "/Admin";
export const PASSWORD_FORGET = "/PasswordForget";
export const Overview = "/Overview";
export const About = "/About";
export const Blog = "/Blog";
export const BlogDetails = "/blogDetails/:blogId";
export const ReportDetails = "/reportDetails/:reportId";
export const ServiceDetails = "/ServiceDetails/:ServiceId";
export const Contact = "/Contact";
export const PostBlog = "/PostBlog";
export const Billing = "/Billing";
export const Legal = "/Legal"
export const Reports = "/Reports"